var map = {
	"./index.js": "gyMJ",
	"./login.js": "M9A7"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "NA1j";


//////////////////
// WEBPACK FOOTER
// ./src/api .js
// module id = NA1j
// module chunks = 2